export default __webpack_public_path__ + "static/media/img-industry-education.16f3a8f9.svg";